import { Clock } from "lucide-react";

export default function QuoteSla({ className = "" }) {
  return (
    <p
      data-testid="quote-sla-badge"
      className={`inline-flex items-center gap-2 border border-arsenal/40 bg-arsenal/10 px-4 py-2.5 font-mono text-[11px] tracking-[0.18em] text-slate-200 ${className}`}
    >
      <Clock className="h-3.5 w-3.5 text-arsenal" />
      WE REPLY TO EVERY QUOTE REQUEST WITHIN 2 BUSINESS DAYS
    </p>
  );
}
